import React from 'react';
import Hamburger from "./Hamburger";
import { Link } from 'react-router-dom';
import WaitlistButton from '../common/components/waitlist/WaitlistButton';
import { useLocation } from 'react-router-dom';

export default function Nav({hamburgerOpen, toggleHamburger}){

  const [aboutSelected, setAboutSelected] = React.useState(false);
  const [howItWorksSelected, setHowItWorksSelected] = React.useState(false);
  const [calculatorSelected, setCalculatorSelected] = React.useState(false);
  const [showWaitlistButton, setShowWaitlistButton] = React.useState(false);
  const location = useLocation();

  const handleScroll = React.useCallback((event) => { 
    setShowWaitlistButton(window.pageYOffset > 260);
  }, []);

  React.useEffect(() => {
    if (typeof window !== "undefined") {
      setAboutSelected(window.location.pathname === '/about-us');
      setHowItWorksSelected(window.location.pathname === '/how-it-works');
      setCalculatorSelected(window.location.pathname === '/debt-payoff-calculator');   
      
      if (window.location.pathname === '/') {
        setShowWaitlistButton(window.pageYOffset > 260);
        window.addEventListener("scroll", handleScroll);
      } else {
        window.removeEventListener("scroll", handleScroll);
        setShowWaitlistButton(true);
      }
    }
  }, [location, handleScroll]);

  function handleLinkClicked() {
    if (!hamburgerOpen) {
      return;
    }
    toggleHamburger();
  }

  return (
    <div>
      <div className="navigation">
        <div className='waitlist-container'>
          <WaitlistButton />
        </div>
        <ul>
          <li><Link to='/about-us' className={`no-link ${aboutSelected ? 'nav-selected' : ''}`} onClick={handleLinkClicked}>About us</Link></li>
          <li><Link to='/how-it-works' className={`no-link ${howItWorksSelected ? 'nav-selected' : ''}`} onClick={handleLinkClicked}>How it works</Link></li>
          <li><Link to='/debt-payoff-calculator' className={`no-link ${calculatorSelected ? 'nav-selected' : ''}`} onClick={handleLinkClicked}>Calculator</Link></li>
          <li><a href='/financial-wellness-blog/' className='no-link'>Blog</a></li>
          <li><WaitlistButton onClick={handleLinkClicked} checkQueryParam={true} /></li>
        </ul>
        <div className="hamburger-container" onClick={toggleHamburger}>
          <Hamburger isOpen={hamburgerOpen}/>
        </div>
      </div>

      <style jsx="true">{`
        .navigation {
          display: flex;
          justify-content: right;
          width: 100%;
        }

        .navigation .waitlist-container {
          display: none;
          padding: 4px 20px 0 0;
          transition: opacity 0.3s linear;
        }
        
        .navigation ul {
          display:flex;
          flex-wrap: wrap;
          float: right;
          margin: 0px;
          padding-right: 154px;
          overflow: hidden;
          gap: 30px;
          transition: opacity 0.3s linear;
        }

        .navigation ul li {
          list-style-type: none;
          padding-right: 10px;
          text-align: center;
          font-weight: 500;
          font-size: 17px;
          line-height: 20px;
        }

        .navigation ul li {
          padding-top: 40px;
        }

        .navigation ul li:last-child {
          padding-top: 20px;
        }

        .hamburger-container {
          display: none;
          position: absolute;
          z-index: 6;
          right: 20px;
          top: 40px;
        } 

        .nav-selected {
          text-decoration: underline;
          text-underline-offset: 4px;
          text-decoration-color: #B5058E;
        }

        @media (max-width: 1200px) {
          .navigation ul {
            padding-right: 0px;
          }
        }

        @media (max-width: 767px) {         
          .hamburger-container {
            display: block;
            z-index: 6;
          }
      
          .navigation ul {
            display: block;
            position: absolute;
            opacity: ${hamburgerOpen ? 1 : 0};
            background-color: #FFFFFF;
            height: 100%;
            width: 100%;
            margin-top: 80px;                  
          }

          .navigation ul li {
            padding-top: 60px;
          }

          .navigation ul li:last-child {
            padding-top: 60px;
          }

          .navigation .waitlist-container {
            display: block;
            opacity: ${(hamburgerOpen || !showWaitlistButton) ? 0 : 1};
          }

          .nav-selected {
            text-decoration: none;
          }
        }
        
        @media (max-width: 480px) {
          .hamburger-container {
            top: 26px;
          }

          .navigation .waitlist-container {
            margin-top: 12px;
          }
        }
          
      `}</style>
        </div>
    )

}